/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryDownloadResponse
 */
export interface RevisdomAPIViewModelsEntryDownloadResponse {
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryDownloadResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryDownloadResponse
     */
    url?: string | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryDownloadResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryDownloadResponse(value: object): value is RevisdomAPIViewModelsEntryDownloadResponse {
    return true;
}

export function RevisdomAPIViewModelsEntryDownloadResponseFromJSON(json: any): RevisdomAPIViewModelsEntryDownloadResponse {
    return RevisdomAPIViewModelsEntryDownloadResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDownloadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryDownloadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function RevisdomAPIViewModelsEntryDownloadResponseToJSON(json: any): RevisdomAPIViewModelsEntryDownloadResponse {
    return RevisdomAPIViewModelsEntryDownloadResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryDownloadResponseToJSONTyped(value?: RevisdomAPIViewModelsEntryDownloadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'url': value['url'],
    };
}

